import React from 'react';
import { LeftSidebar } from '../components/LeftSidebar';
import { PublisherCard } from '../components/PublisherCard';
import { ArticleContent } from '../components/ArticleContent';
import { Footer } from '../components/Footer';
import { Menu, Search, Bell } from 'lucide-react';
export function ArticlePage() {
  return <div className="min-h-screen bg-white" data-id="element-188">
      {/* Mobile Header */}
      <div className="lg:hidden sticky top-0 z-50 bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between" data-id="element-189">
        <div className="flex items-center gap-3" data-id="element-190">
          <button className="p-1 -ml-1 text-gray-600" data-id="element-191">
            <Menu className="w-6 h-6" data-id="element-192" />
          </button>
          <div className="flex items-center gap-1 font-bold text-lg tracking-tight text-gray-900" data-id="element-193">
            <div className="relative w-6 h-6" data-id="element-194">
              <div className="absolute inset-0 bg-red-500 transform skew-x-12 rounded-sm" data-id="element-195"></div>
              <span className="absolute inset-0 flex items-center justify-center text-white font-black italic text-sm" data-id="element-196">
                N
              </span>
            </div>
            NEWSBREAK
          </div>
        </div>
        <div className="flex items-center gap-3" data-id="element-197">
          <Search className="w-5 h-5 text-gray-500" data-id="element-198" />
          <Bell className="w-5 h-5 text-gray-500" data-id="element-199" />
        </div>
      </div>

      {/* Main Layout Grid */}
      <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-[240px_1fr_320px] gap-0 lg:gap-12 items-start" data-id="element-200">
        {/* Left Sidebar (Desktop) */}
        <LeftSidebar data-id="element-201" />

        {/* Main Content Area */}
        <main className="px-4 md:px-8 lg:px-0 min-w-0" data-id="element-202">
          <ArticleContent data-id="element-203" />
        </main>

        {/* Right Sidebar (Desktop) */}
        <div className="hidden lg:block pr-6 pt-6" data-id="element-204">
          <PublisherCard data-id="element-205" />
        </div>

        {/* Mobile Publisher Info (Bottom) */}
        <div className="lg:hidden px-4 pb-12" data-id="element-206">
          <div className="border-t border-gray-200 pt-8" data-id="element-207">
            <h3 className="font-bold text-gray-900 mb-4" data-id="element-208">
              About the Publisher
            </h3>
            <PublisherCard data-id="element-209" />
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer data-id="element-210" />
    </div>;
}